import React from "react";
import { Link } from "react-router-dom";
import { Compass, Home, Store, MapPin, LifeBuoy } from "lucide-react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seo from "../../components/Seo/Seo";
import { PAGES } from "../../seo/seo.config";
import "./NotFoundScreen.css";

const SUGGESTIONS = [
  { to: "/", label: "Home", icon: Home },
  { to: "/shops", label: "All Salons", icon: Store },
  { to: "/nearby", label: "Salons Near Me", icon: MapPin },
  { to: "/contact", label: "Contact & Support", icon: LifeBuoy },
];

export default function NotFoundScreen() {
  return (
    <div className="nf404-page">
      {/*
        Kept out of the index: this renders on any unmatched URL, and a static
        host returns 200 for it, so noindex is what stops soft-404s piling up
        in Search Console.
      */}
      <Seo
        title={PAGES.notFound.title}
        description={PAGES.notFound.description}
        noindex
      />
      <Header />

      <main className="nf404-main">
        <div className="nf404-code" aria-hidden="true">
          404
        </div>
        <Compass className="nf404-icon" size={44} strokeWidth={1.5} />
        <h1>This page doesn't exist</h1>
        <p>
          The link may be broken or the page may have moved. Here's where most
          people go next.
        </p>

        <nav className="nf404-links" aria-label="Suggested pages">
          {SUGGESTIONS.map(({ to, label, icon: Icon }) => (
            <Link key={to} to={to} className="nf404-link">
              <Icon size={16} />
              {label}
            </Link>
          ))}
        </nav>

        <p className="nf404-sitemap">
          Or browse the <Link to="/sitemap">full sitemap</Link>.
        </p>
      </main>

      <Footer />
    </div>
  );
}
